/*
 * @Author: libo 
 * @Date: 2020-11-13 11:24:42 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2022-04-06 19:50:41
 */

<!--过户页面-->
<template>
<a-spin :spinning="confirmLoading">
    <div class="form-contain">
      <div>
        <a-row :gutter="16">
          <a-divider orientation="left">
              {{ $t('高拍仪操作') }}
          </a-divider>
          <a-col :span="24" style="margin-bottom: 10px;">
              <a-button type="primary" @click="onTransferAgreement" style="margin-right: 20px;">
                  {{ $t('过户协议') }}
              </a-button>
          </a-col>
        </a-row>
      </div>
      <a-divider orientation="left">{{ $t('表具信息') }}</a-divider>
        <detail-list>
          <detail-list-item :term="$t('表编号')">{{model.meterId}}</detail-list-item>
          <detail-list-item :term="$t('表类型')">{{model.meterTypeName}}</detail-list-item>
          <detail-list-item :term="$t('计费起始读数')">{{model.userMeterStartNum}}</detail-list-item>
          <detail-list-item :term="$t('运营商')">{{$t(netTypeObj[model.mtIotType])}}</detail-list-item>
          <detail-list-item :term="$t('IMEI号')">{{model.mtImei}}</detail-list-item>
          <detail-list-item :term="$t('SIM卡号')">{{model.mtSim}}</detail-list-item>
          <detail-list-item :term="$t('表安装地址')">{{model.userMeterAddr}}</detail-list-item>
        </detail-list>
        <a-divider orientation="left">{{ $t('旧用户信息') }}</a-divider>
        <detail-list>
          <detail-list-item :term="$t('用户编号')">{{model.userId}}</detail-list-item>
          <detail-list-item :term="$t('用户姓名')">{{model.userName}}</detail-list-item>
          <detail-list-item :term="$t('手机号码')">{{model.userPhone}}</detail-list-item>
          <detail-list-item :term="$t('身份证号')">{{model.userIdNumber}}</detail-list-item>
          <!-- <detail-list-item term="户型ID">{{model.userHouseholdCode}}</detail-list-item> -->
          <detail-list-item :term="$t('类型名称')">{{model.userTypeName}}</detail-list-item>
          <detail-list-item :term="$t('价格名称')">{{model.wtName}}</detail-list-item>
          <detail-list-item :term="$t('用水状态')">{{model.userState==0?$t("未开始计费"):model.userState==1?$t("已开始计费"):''}}</detail-list-item>
          <!-- <detail-list-item term="区域名称">{{model.userAreaName}}</detail-list-item> -->
          <detail-list-item :term="$t('营收编号')">{{model.userPayId}}</detail-list-item>
          <!-- <detail-list-item term="类型">{{model.userIdType==1?"自然人":model.userIdType==0?"企业":""}}</detail-list-item> -->
          <detail-list-item :term="$t('优惠信息')">{{'user_free_type'|filterDictTextByCache(model.userFreeinfo)}}</detail-list-item>
          <detail-list-item :term="$t('是否允许缴费')">{{model.userPayState==0?$t("不允许"):model.userPayState==1?$t("允许"):''}}</detail-list-item>
          <detail-list-item :term="$t('用户地址')" style="width: 66.66%;">{{model.userAreaName.slice(model.userAreaName.indexOf('-')+1,model.userAreaName.length)+'-'+model.userAddr}}</detail-list-item>
        </detail-list>
        <detail-list :col="1">
          <detail-list-item :term="$t('小区或村庄名')">{{model.userCommName}}</detail-list-item>
        </detail-list>
        <a-form :form="form" slot="detail" :colon="false" layout="vertical">
        <a-divider orientation="left">{{ $t('过户操作') }}</a-divider>
        <a-row :gutter="16">
          <a-col :span="24">
            <a-form-item :label="$t('过户原因描述')" >
              <a-textarea v-decorator="['userTransferReason',validatorRules.userTransferReason]" :placeholder="$t('请输入过户原因描述')" :rows="3" style="width:100%" />
            </a-form-item>
          </a-col>
          <!--
          <a-col :span="12">
            <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol" >
              <a-textarea v-decorator="['remark']" rows="1" placeholder="请输入备注" style="width:100%"/>
            </a-form-item>
          </a-col>
          -->
        </a-row>
        <a-divider orientation="left">{{ $t('新用户信息') }}</a-divider>
        <a-row :gutter="16">
          <a-col :span="8">
            <a-form-item :label="$t('用户编号')">
              <a-input v-model="model.userId" :readOnly="true" style="background-color:rgb(238,238,238)"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('用户姓名')">
              <a-input v-decorator="['userName',validatorRules.userName]" :placeholder="$t('请输入用户姓名')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('手机号码')">
              <a-input v-decorator="['userPhone',validatorRules.userPhone]" :placeholder="$t('请输入用户手机号')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('身份证号')">
              <a-input v-decorator="['userIdNumber',validatorRules.userIdNumber]" :placeholder="$t('请输入身份证号')"></a-input>
            </a-form-item>
          </a-col>
          <!--
          <a-col :span="8">
            <a-form-item label="用水状态" >
              <j-dict-select-tag v-decorator="['userState',validatorRules.userState]" :triggerChange="true" placeholder="请选择用水状态" dictCode="user_state" style="width:100%"/>
            </a-form-item>
          </a-col>
          -->
          <a-col :span="8">
            <a-form-item :label="$t('价格名称')">
              <a-select v-decorator="['userPriceCode',validatorRules.userPriceCode]" :placeholder="$t('请选择用户价格编码')" :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}">
                <a-select-option v-for="(data,index) in userPriceCode" :key="data.id" :value="data.id">
                  {{data.wtName}}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('用水户型')">
              <a-select v-decorator="['userHouseholdCode',validatorRules.userHouseholdCode]" :placeholder="$t('请选择用水户型')" :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}">
                <a-select-option v-for="(data,index) in userHouseholdCodeList" :key="data.id" :value="data.id">
                  {{ data.htName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('用户类型')">
              <a-select v-decorator="['userTypeCode',validatorRules.userTypeCode]" :placeholder="$t('请选择用户类型')" :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}">
                <a-select-option v-for="(data,index) in userTypeList" :key="data.id" :value="data.id">
                  {{data.utName}}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('身份类型')" >
              <a-select  v-decorator="['userIdType']" :placeholder="$t('请选择身份类型')" :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}">
                <a-select-option :value="1">
                  {{ $t('自然人') }}
                </a-select-option>
                <a-select-option :value="0">
                  {{ $t('企业') }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('优惠信息')">
              <j-dict-select-tag v-decorator="['userFreeinfo',validatorRules.userFreeinfo]" :triggerChange="true" :placeholder="$t('请选择水表用途')" dictCode="user_free_type" style="width:100%"/>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <WaterAgreementModal ref="WaterAgreementForm" @ok="WaterAgreementReturn"></WaterAgreementModal>
  </a-spin>
</template>

<script>
  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import {listSize } from '@/utils/util'
  import {filterDictTextByCache} from '@/components/dict/JDictSelectUtil'
  import {netTypeObj} from '@/utils/constants/protocolConstant'
  import PageLayout from '@/components/page/PageLayout'
  import {CardIdNumberPattern,PhoneNumberPattern} from '@/utils/regPattern'
  import DetailList from '@/components/tools/DetailList'
  import WaterAgreementModal from './WaterAgreementModal'
  const DetailListItem = DetailList.Item
  export default {
    name: 'MeterAssignedForm',
    components: {
      PageLayout,
      DetailList,
      DetailListItem,
      WaterAgreementModal
    },
    filters: {
      filterDictTextByCache
    },
    data () {
      return {
        netTypeObj,
        activeKey:[1,2],
        form: this.$form.createForm(this),
        model: {},
        confirmLoading: false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        userHouseholdCodeList:[], // 用户户型
        userTypeList:[], //  类型编码
        userPriceCode:[], // 价格编码
        url: {
          add: "/jeecg-charge/meter/meterUserinfo/add",
          edit: "/jeecg-charge/meter/meterUserinfoTransferRecord/doTransferTask",
          queryById: "/jeecg-charge/meter/meterUserinfo/queryById",
          userHouseholdCodeList: "/jeecg-charge/meter/meterHousehold/list", //用户户型列表接口
          userTypeList:"/jeecg-charge/meter/meterUserType/list",  //类别编码列表接口
          userPriceCode:"/jeecg-charge/meter/meterPriceinfo/list", //价格编码列表接口
        },
      }
    },
    computed: {
      // i18n：校验消息使用 computed 以响应语言切换
      validatorRules() {
        return {
          userName:{  //用户姓名
            rules:[
              {required:true, message:this.$t('请输入用户姓名！')},
            ]
          },
          userPhone:{  //手机号码
            rules:[
              {required:true , message:this.$t('请输入手机号码'),whitespace: true},
              {pattern: PhoneNumberPattern,message: this.$t('请输入正确的手机号码')}
            ]
          },
          userIdNumber:{  //身份证号
            rules:[
              {required:false ,pattern: CardIdNumberPattern,message: this.$t('请输入正确的身份证号'),whitespace: true}
            ]
          },
          userPriceCode:{  //身份证号
            rules:[
              {required:true, message:this.$t('请选择用户价格编码！')},
            ]
          },
          userTransferReason:{ //过户原因
            rules:[
              {required:true,message:this.$t('请输入过户原因')},
            ]
          },
          /*
          userState:{ //用水状态
            rules:[
              {required:true,message:'请输入用水状态'}
            ]
          }*/
        }
      },
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          // this.form.setFieldsValue(pick(this.model,'meterId','userId','userName','userHouseholdCode','userTypeCode','userPhone','userPriceCode','userAddr','userMeterAddr','userMeterLng','userMeterLat','userAddrId','userPayId','userIdNumber','userIdType','userAreaId','userAreaName','userCommName','userState','userMeterStartNum','userMeterOpenNum','userPayState','userFreeinfo','userValveOpenorclose','createTime','createBy','remark'))
          this.form.setFieldsValue({userPriceCode: this.model.userPriceCode});
        })
        this.queryUserHouseholdCodeList()
        this.queryUserTypeList()
        this.queryUserPriceCode()

      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'post';
            }
            let formData = Object.assign(this.model,values);
            formData.meterId = this.model.meterId
            formData.id = this.model.id
            formData.userId = this.model.userId
            console.log("过户提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                setTimeout(() => {
                  that.$emit('ok');
                },400)
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'meterId','userId','userHouseholdCode','userTypeCode','userPhone','userPriceCode','userAddr','userMeterAddr','userMeterLng','userMeterLat','userAddrId','userPayId','userIdNumber','userIdType','userAreaId','userAreaName','userCommName',/*'userState',*/'userMeterStartNum','userMeterOpenNum','userPayState','userFreeinfo','userValveOpenorclose','createTime','createBy','remark'))
      },
      queryUserHouseholdCodeList() {  //用户户型
        let params = {}
        params.pageNo = 1;
        params.pageSize = listSize;
        getAction(this.url.userHouseholdCodeList, params).then((res) => {
          if(res.success){
           this.userHouseholdCodeList = res.result.records;
          }
        })
      },
      queryUserTypeList() {  //类别编码
        let params = {}
        params.pageNo = 1;
        params.pageSize = listSize;
        getAction(this.url.userTypeList, params).then((res) => {
          if(res.success){
           this.userTypeList = res.result.records;
          }
        })
      },
      queryUserPriceCode() {  //价格编码
        let params = {}
        params.pageNo = 1;
        params.pageSize = listSize;
        getAction(this.url.userPriceCode, params).then((res) => {
          if(res.success){
            this.userPriceCode = res.result.records;
          }
        }) 
      },
      onTransferAgreement(){
        let m = this.model || {};
        let userFields = {
          userName: m.userName,
          userAddr: m.userAddr,
          userPhone: m.userPhone,
          userIdNumber: m.userIdNumber,
          waterUseType: m.userTypeCode
        };
        this.$refs.WaterAgreementForm.init(this.$t('过户'), userFields);
      },
      WaterAgreementReturn(row){
        
      }
    }
  }
</script>

<style scoped>
.ant-form-item >>> .ant-select{
  width: 100%;
}
.detail-list >>> .content{
    line-height: normal;
}
</style>
